module.exports = __webpack_public_path__ + "static/media/battle_cats_tianyu.3e9b5ad7.jpg";